import React from "react";
import classes from "../Nochapter/Nochapter.module.css";
const Nochapter = () => {
  return (
    <div className={classes["container"]}>
      <p>There is no chapter to show.Please choose another course.</p>
    </div>
  );
};

export default Nochapter;
